import React, { useState } from "react";

export default function ContactInfo({ data, onChange }) {
  const [localData, setLocalData] = useState(data);

  const handleInputChange = (key, value) => {
    const updatedData = { ...localData, [key]: value };
    setLocalData(updatedData);
    onChange(updatedData); // Send all data back as flat structure
  };
  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Contact Information</h2>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block mb-1">Residential Address</label>
          <textarea
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Residential Address"
            onChange={(e) =>
              handleInputChange("residency_address", e.target.value)
            }
          ></textarea>
        </div>
        <div>
          <label className="block mb-1">Temporary Address</label>
          <textarea
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Temporary Address"
            onChange={(e) =>
              handleInputChange("temporary_address", e.target.value)
            }
          ></textarea>
        </div>
        <div>
          <label className="block mb-1">Primary Contact Number</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Primary Contact Number"
            onChange={(e) =>
              handleInputChange("primary_contact_no", e.target.value)
            }
          />
        </div>
        <div>
          <label className="block mb-1">Secondary Contact Number</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Secondary Contact Number"
            onChange={(e) =>
              handleInputChange("secondary_contact_no", e.target.value)
            }
          />
        </div>
        <div>
          <label className="block mb-1">Email Address</label>
          <input
            type="email"
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Email Address"
            onChange={(e) => handleInputChange("email", e.target.value)}
          />
        </div>
        <div>
          <label className="block mb-1">Emergency Contact Name</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Emergency Contact Name"
            onChange={(e) =>
              handleInputChange("emergency_contact_name", e.target.value)
            }
          />
        </div>
        <div>
          <label className="block mb-1">Emergency Contact Relationship</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Relationship"
            onChange={(e) =>
              handleInputChange(
                "emergency_contact_relationship",
                e.target.value
              )
            }
          />
        </div>
        <div>
          <label className="block mb-1">Emergency Contact Number</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Emergency Contact Number"
            onChange={(e) =>
              handleInputChange("emergency_contact_no", e.target.value)
            }
          />
        </div>
      </div>
    </div>
  );
}
